import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { lunaStreamsClient } from 'api';
import i18n from 'translations/i18n';

const initialState = {
  state: 'loading',
  version: undefined,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setState(state, { payload }) {
      state.state = payload;
    },
    setVersion(state, { payload }) {
      state.version = payload;
    },
  },
});

export const initApp = async (dispatch) => {
  try {
    await lunaStreamsClient.healthcheck();
    const version = await lunaStreamsClient.version();
    dispatch(appSlice.actions.setVersion(version));
    dispatch(appSlice.actions.setState('loaded'));
  } catch (e) {
    dispatch(appSlice.actions.setState('failed'));
    toast.error(i18n.t('api:unavailable', { service: 'Luna Streams API' }));
    throw e;
  }
};

export default appSlice.reducer;
